var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"components__href-target",class:( _obj = {
    'href-target--disabled': _vm.disabled,
    'href-target--active': !_vm.disabled && _vm.target
  }, _obj[_vm.selectionClassName] = _vm.selected, _obj ),on:{"click":_vm.handleClick}},[(_vm.selection)?_c('input',{staticClass:"selection-checkbox",attrs:{"type":"checkbox","name":_vm.selection.name},domProps:{"value":_vm.selection.value,"checked":_vm.selected}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }